const PLACEHOLDER_MARKERS = ["placeholder-combo", "Σύντομα διαθέσιμη"];

function isPlaceholderImage(img) {
  if (!img) return false;
  const src = img.currentSrc || img.src || "";
  const alt = img.alt || "";
  return PLACEHOLDER_MARKERS.some((m) => src.includes(m) || alt.includes(m));
}

function findGalleryRoot() {
  return (
    document.querySelector("[data-product-media-gallery]") ||
    document.querySelector(".product-media-gallery") ||
    document.querySelector(".product-information")
  );
}

function ensureEmptyState(gallery) {
  let empty = gallery.querySelector(".aph-combo-empty");
  if (!empty) {
    empty = document.createElement("div");
    empty.className = "aph-combo-empty";
    empty.textContent = "Φωτογραφία σύντομα";
    gallery.prepend(empty);
  }
  return empty;
}

function updateComboPlaceholder() {
  const gallery = findGalleryRoot();
  if (!gallery) return;

  const activeImg =
    gallery.querySelector(".product-media.is-active img, .product-media-gallery__media.is-active img, .product-media img, img[src*='cdn/shop']") ||
    gallery.querySelector("img");

  const empty = ensureEmptyState(gallery);
  const comboMode = isPlaceholderImage(activeImg);

  document.body.classList.toggle("aph-combo-mode", comboMode);
  empty.classList.toggle("is-visible", comboMode);
}

function initComboPlaceholder() {
  updateComboPlaceholder();

  document.addEventListener("variant:change", updateComboPlaceholder);
  document.addEventListener("change", (event) => {
    const target = event.target;
    if (!(target instanceof HTMLElement)) return;
    if (target.matches('input[name*="options"], select[name*="options"], [data-variant-picker] *')) {
      window.setTimeout(updateComboPlaceholder, 60);
    }
  });

  const observer = new MutationObserver(() => updateComboPlaceholder());
  const gallery = findGalleryRoot();
  if (gallery) {
    observer.observe(gallery, { childList: true, subtree: true, attributes: true, attributeFilter: ["src", "class"] });
  }
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initComboPlaceholder);
} else {
  initComboPlaceholder();
}

document.addEventListener("shopify:section:load", initComboPlaceholder);
